import { render, staticRenderFns } from "./BizChain.vue?vue&type=template&id=16362016&"
import script from "./BizChain.vue?vue&type=script&lang=js&"
export * from "./BizChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports